// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2hMVt","right":"Footer_right__3-kJV","buttons":"Footer_buttons__jGsgc"};